import React from 'react';
import { render } from 'react-dom';

import App from './App';
import { StateProvider } from './ContextApi/StateProvider';
import reducer, { initialState } from './ContextApi/Reducer';

import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

const mountApp = document.getElementById('root');
render(
  <DndProvider backend={HTML5Backend}>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
    </StateProvider>
  </DndProvider>,
  mountApp
);

if (process.env.NODE_ENV === 'development') {
  module.hot.accept();
}
